<template>
  <div class='mt-5 px-0 mx-4'>
    <!-- <h1>Contacts</h1> -->
    <contacts-table :items="this.displayedData" v-on:switchOwnershipTop="switchOwnershipTop($event)"></contacts-table>
  </div>
</template>

<script>
  // import axios from '../../../static/axios.js' 
  import Contact from '@/components/contacts/Contact.vue'
  // import FilterBox from '@/components/artworks/FilterBox'
  import ContactsTable from '@/components/contacts/ContactsTable'

  export default {

    data: function () {
      return {
        displayedData: [],
        contact: {
          name: ''
        },
        contacts: [],
        results: []
      }
    },

    beforeRouteEnter (to, from, next) {
      // console.log('beforeRouteEnter')
      next(vm => vm.switchOwnership(to))
    },

    beforeRouteUpdate (to, from, next) {
      // console.log('beforeRouteUpdate')
      this.displayedData = null
      this.switchOwnership(to)
      next()
    },
    
    created: function () {
      // console.log('created')
      this.$store.dispatch('loadContacts')
      this.displayedData = this.$store.state.contacts
    },
    
    updated: function () {
      // console.log('updated')
      this.$store.dispatch('loadContacts')
      this.displayedData = this.$store.state.contacts
    },

    methods: {
      switchOwnershipTop(switchStatus) {
        // console.log('switchOwnershipTop')
        // console.log(switchStatus)
        if (switchStatus) {
        } else {
          this.switchOwnership(this.$route)
        }
      },
      switchOwnership (to) {
        // console.log('switchOwnership')
        this.displayedData = this.processedContacts.filter(function(a) {
          return a.cateogory == to.params.ownership
        })
      }
    },

    computed: {
      title() {
        let title = 'Contacts'
        // if (this.$route.fullPath == '/contacts/oldMasters') {
        //   title = 'Old Masters'
        // } else 
        if (this.$route.fullPath == '/contacts/deaccession') {
          title = 'Deaccessioned'
        } else if (this.$route.fullPath == '/contacts/collection') {
          title = 'TBA21 Collection'
        } else if (this.$route.fullPath == '/contacts/pacFvh') {
          title = 'Private Art Collection FTB'
        } else if (this.$route.fullPath == '/contacts/pdcFvh') {
          title = 'Private Design Collection FTB'
        } else if (this.$route.fullPath == '/contacts/pacMr') {
          title = 'Private Art Collection MR'
        }
        return title
      },      
      processedContacts () {
        let contacts = this.results
        this.contacts.map(contact => {
          let a = contact
          contact.first_name = a ? a.first_name : 'nema meno'
        })
        return contacts
      }
    },
    
    filters: {
      capitalize: function (a) {
        if (!a) return ''
        a = a.toString()
        return a.charAt(0).toUpperCase() + a.slice(1)
      }
    },

    components: {
      Contact,ContactsTable
    }
  
  }

  // switchCategory (to) {
  //   switch (to.params.contact_categories) {
  //     case 'artwork_acquisition_source':
  //       this.displayedData = this.$store.state.collection
  //       break
  //     case 'device_acquisition_company':
  //       this.displayedData = this.$store.state.pac_fvh
  //       break
  //   }
  // },
  // filterContacts (category) {
  //   contacts = this.results.filter(function(c)  {
  //       return results.filter(function(c) {
  //         return c.category == category
  //     }).length > 1
  //   })
  //   this.displayedData = contacts

  //   for (contact in this.results) {
  //     if (contact.category == category) {
  //         this.results[artist].artworks[artwork].splice(1,1)
  //     }
  //   }
  //   let artists = ''
  //   artists = this.storedData.filter(function(artist)  {
  //     return artist.artworks.filter(function(artwork) {
  //       return artwork.ownership == ownership
  //     }).length > 1
  //   })
  //   this.displayedData = artists
  // },

</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/contacts/Contacts.vue